// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ingredient-details_wrapper__25vk4","detailsContainer":"ingredient-details_detailsContainer__znhvP","details":"ingredient-details_details__1BQbK"};